import _ from 'underscore';

import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { Set } from '../../ts/models/Set';


/** An item, with its associated error data from a "content action" API */
export interface IErrorItem<T> {
  item: T;
  error: IError;
}

/**
 * This class encapsulates the results of a "content action" performed on a set of items.
 * It can be passed into ContentActionNotification to display that itemized result to the user.
 */
export class MultipleItemResult<T> {

  public successCount: number;
  public errorCount: number;

  constructor(private items: Set<T>,
              private serverResult: IResult) {
    if (serverResult) {
      this.errorCount = serverResult.errors ? serverResult.errors.length : 0;
    } else {
      this.errorCount = 0;
    }
    this.successCount = items.size() - this.errorCount;
  }

  public anySucceeded(): boolean {
    return this.successCount > 0;
  }

  public anyFailed(): boolean {
    return this.errorCount > 0;
  }

  public errorItems(): IErrorItem<T>[] {
    return _.map(this.serverResult.errors, (error: IError) => {
      return {
        error: error,
        item: this.items.get(error.id)
      };
    });
  }

  public firstSuccessfulItem(): T {
    if (this.successCount === 0) {
      return null;
    }
    return _.once(() => {
      const errorIds = this.errorCount ?  _.map(this.serverResult.errors, (error: IError) => error.id) : [];
      const successIds = _.difference(this.items.keys(), errorIds);
      return this.items.get(successIds[0]);
    })();
  }

  public firstErrorItem(): T | undefined {
    return this.anyFailed() ? this.errorItems()[0].item : undefined;
  }
}
